<script lang="ts">
  import Checkbox from '$shared/atoms/Checkbox/Checkbox.svelte';

  interface Props {
    selectedCount: number;
    onchange?: (e: Event) => void;
    children?: import('svelte').Snippet;
  }

  let { selectedCount, onchange, children }: Props = $props();
</script>

<div class="selectable-checkbox-action">
  <div class="checkbox-item">
    <div class="checkbox-container">
      <Checkbox indeterminateCheck checked {onchange} />
    </div>
    <div class="label">{selectedCount} Selected</div>
    {@render children?.()}
  </div>
</div>

<style>
  .selectable-checkbox-action {
    border-radius: 4px;
    padding: 8px;
    background-color: var(--light-blue);
    box-sizing: border-box;
    height: 50px;
    display: flex;
    align-items: center;
  }
  .checkbox-item {
    display: flex;
    align-items: center;
  }
  .checkbox-container {
    width: 30px;
    padding-left: 4px;
  }
</style>
